module.exports = __webpack_public_path__ + "resources/img/img_db-i_cloud01-jp.65658c36b87fb03acb7f3b8fc03afe0e.png";